<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item style="line-height: 28px;">物料列表</el-breadcrumb-item>
      <el-breadcrumb-item v-if="showBtn==3||showBtn<1">
        <router-link to='addGoodsCatalog'>
          <el-button size="mini" type="primary">添加物料目录</el-button>
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="">
        <el-upload
          v-if="showBtn==3||showBtn<1"
          class="upload-demo"
          :http-request="importCatalog"
          action=""
          :show-file-list="false">
          <el-button size="mini" type="primary">导入物料目录</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="" v-if="showBtn==3||showBtn<1">
        <el-button size="mini" type="primary" @click="downloadImportCatalog">导入物料目录示例</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button size="mini" type="primary" @click="exportCatalog">导出物料目录</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-select v-model="sreachData.examine" placeholder="请选择">
        <el-option label="全部" value="-1"></el-option>
        <el-option label="待审核" value="0"></el-option>
        <el-option label="审核通过" value="1"></el-option>
        <el-option label="审核不通过" value="2"></el-option>
      </el-select>
      <el-form-item label="">
        <el-input v-model="sreachData.words" placeholder="编码|名称|描述/规格">
          <template slot="prepend"><i class="el-icon-search"></i></template>
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="list">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="gcode"
        label="物料编码">
      </el-table-column>
      <el-table-column
        prop="title"
        label="物料名称">
      </el-table-column>
      <el-table-column
        prop="unit"
        width="110"
        label="单位">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="物料描述/规格">
      </el-table-column>
      <el-table-column
        prop="status"
        width="100"
        label="状态">
      </el-table-column>
      <el-table-column
        label="操作"
        width="340">
        <template slot-scope="scope">
          <el-button v-show="showBtn<1&&scope.row.status=='待审核'" size="mini" type="success" plain @click="goodsOn(scope.row)">审核通过</el-button>
          <el-button v-show="showBtn<1&&scope.row.status=='待审核'" size="mini" type="danger" plain @click="goodsOff(scope.row)">审核不通过</el-button>
          <el-button v-if="(showBtn<1||showBtn==3)&&scope.row.status!='审核不通过'" size="mini" type="success" plain @click="editGoods(scope.row.id)">编辑</el-button>
          <el-button v-else-if="showBtn<1||showBtn==3" size="mini" type="warning" plain @click="editGoods(scope.row.id)">重新提交</el-button>
          <el-button v-else size="mini" type="success" plain @click="editGoods(scope.row.id)">查看</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delGoods(scope.row.id)" 
            title="确定删除物料吗？"
          >
            <el-button size="mini" type="danger" v-show="showBtn<1||(showBtn==3&&scope.row.status!='上架')" plain slot="reference">删除</el-button>
          </el-popconfirm>
          
        </template>
      </el-table-column>
    </el-table>
    <p>
      <span style="float:left" v-if="showBtn<1||showBtn==3">
        <el-button @click="delGoods(0)" v-if="showBtn<1">删除所选</el-button>
        <el-button type="primary" @click="examineAllGoodsCatalog(0)" v-if="showBtn<1">审核通过</el-button>
      </span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
</el-card>
</template>
<script>
import goodsFunction from "@/api/goods"
  export default {
    data() {
      return {
        showBtn:sessionStorage.getItem('roleid'),
        Selectionids:[],
        tableData:[],
        total:0,
        sreachData:{
          statusName:'',
          limit:10,
          page:1,
          cates:'',
          words:'',
          examine:'-1',
          vcode:sessionStorage.getItem('token'),
        },
        form:{},
      };
    },
    methods: {
      importCatalog(params){
        const file = params.file,form = new FormData();
        form.append("file", file)
        form.append("vcode", sessionStorage.getItem('token'));
        goodsFunction.importCatalog(form,this).then(res=>{
          this.list()
        })
      },
      exportCatalog(){
        goodsFunction.exportCatalog(this.sreachData,this).then(res=>{
          let a = document.createElement('a')
          a.href = res.filepath
          a.click()
        })
      },
      downloadImportCatalog(){
        let a = document.createElement('a')
          a.href = '/upload/导入物料目录示例.xlsx'
          a.click()
      },
      goodsOn(data){
        data.examine = 1
        data.status = 1
        data['vcode'] = sessionStorage.getItem('token')
        goodsFunction.saveGoodsCatalog(data,this).then(res=>{
          this.list()
        })
      },
      goodsOff(data){
        data.examine = 2
        data.status = 1
        data['vcode'] = sessionStorage.getItem('token')
        goodsFunction.saveGoodsCatalog(data,this).then(res=>{
          this.list()
        })
      },
      handleSizeChange(val){
        this.sreachData.limit = val
        this.list()
      },
      handleCurrentChange(val){
        this.sreachData.page = val
        this.list()
      },
      showChangeStatus(){
        this.changeStatusBox = true
      },
      editGoods(id){
        this.$router.push({path: '/home/editGoodsCatalog',query: {id: id}})
      },
      delGoods(id){
        var data = [];
        if(id){
          data.push(id)
        }else{
          data = this.Selectionids
        }
        goodsFunction.delGoodsCatalog({id:data,vcode:sessionStorage.getItem('token')},this).then(res=>{
          this.list()
        })
      },
      examineAllGoodsCatalog(id){
        var data = [];
        if(id){
          data.push(id)
        }else{
          data = this.Selectionids
        }
        goodsFunction.examineAllGoodsCatalog({id:data,vcode:sessionStorage.getItem('token')},this).then(res=>{
          this.list()
        })
      },
      handleSelectionChange(val) {
        this.Selectionids = []
        for(var i in val){
          this.Selectionids.push(val[i].id);
        }
      },
      list() {
        goodsFunction.Cataloglist(this.sreachData,this).then(res=>{
          this.tableData = res.data
          this.total = res.total
        })
      },
      handleClick(tab) {
        this.sreachData.statusName = tab.name
        this.list()
      }
    },
    mounted () {
      this.list()
    }
  };
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/goods/goodsCatalog.vue